import React, { useState, useMemo, useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Gallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const images = [
    {
      src: "/images/properties/mas-capon/web_house_prime.jpeg",
      alt: "Mas Capon - Hauptansicht",
      category: "Garten & Pool",
      subcategory: "house",
      description: "Genießen Sie den atemberaubenden Blick auf das Mas Capon, eingebettet in die malerische Landschaft der Provence. Die traditionelle Architektur mit ihren charakteristischen Natursteinfassaden und provenzalischen Fensterläden verkörpert den authentischen Charme der Region."
    },
    {
      src: "/images/properties/mas-capon/web_house.jpeg",
      alt: "Mas Capon - Hausansicht",
      category: "Garten & Pool",
      subcategory: "house",
      description: "Genießen Sie den atemberaubenden Blick auf das Mas Capon, eingebettet in die malerische Landschaft der Provence. Die traditionelle Architektur mit ihren charakteristischen Natursteinfassaden und provenzalischen Fensterläden verkörpert den authentischen Charme der Region."
    },
    {
      src: "/images/properties/mas-capon/web_pool.jpeg",
      alt: "Beheizter Pool mit Panoramablick",
      category: "Garten & Pool",
      subcategory: "pool",
      description: "Der 15 Meter lange beheizte Salzwasserpool lädt zum Entspannen ein. Umgeben von mediterraner Vegetation und mit Blick auf die provenzalische Landschaft bietet er pure Erholung. Das moderne Pool-Haus mit seiner komfortablen Ausstattung macht den Poolbereich zum perfekten Rückzugsort."
    },
    {
      src: "/images/properties/mas-capon/web_poolhouse.jpeg",
      alt: "Pool-Haus mit Outdoor-Küche",
      category: "Garten & Pool",
      subcategory: "pool",
      description: "Der 15 Meter lange beheizte Salzwasserpool lädt zum Entspannen ein. Umgeben von mediterraner Vegetation und mit Blick auf die provenzalische Landschaft bietet er pure Erholung. Das moderne Pool-Haus mit seiner komfortablen Ausstattung macht den Poolbereich zum perfekten Rückzugsort."
    },
    {
      src: "/images/properties/mas-capon/web_brunnen_garten.jpeg",
      alt: "Mediterraner Garten mit Steinbrunnen",
      category: "Garten & Pool",
      subcategory: "house",
      description: "Der liebevoll gestaltete Garten verbindet mediterrane Pflanzen, Naturstein und einen klassischen Brunnen zu einer ruhigen, provenzalischen Atmosphäre. Zwischen Kräutern, Sukkulenten und Schatten spendenden Bäumen entsteht ein Ort zum Verweilen."
    },
    {
      src: "/images/properties/mas-capon/web_kitchen.jpeg",
      alt: "Moderne Küche mit traditionellen Elementen",
      category: "Küche & Esszimmer",
      description: "Die großzügige Küche vereint modernste Ausstattung mit provenzalischem Flair. Der zentrale Kochbereich mit hochwertigen Geräten und der große Esstisch für 10 Personen machen sie zum kommunikativen Mittelpunkt des Hauses. Große Fenster sorgen für natürliches Licht und einen schönen Ausblick in den Garten."
    },
    {
      src: "/images/properties/mas-capon/web_kitchen2.jpeg",
      alt: "Essbereich mit Gartenblick",
      category: "Küche & Esszimmer",
      description: "Die großzügige Küche vereint modernste Ausstattung mit provenzalischem Flair. Der zentrale Kochbereich mit hochwertigen Geräten und der große Esstisch für 10 Personen machen sie zum kommunikativen Mittelpunkt des Hauses. Große Fenster sorgen für natürliches Licht und einen schönen Ausblick in den Garten."
    },
    {
      src: "/images/properties/mas-capon/web_eingang.jpeg",
      alt: "Einladender Eingangsbereich",
      category: "Wohnzimmer",
      description: "Das lichtdurchflutete Wohnzimmer besticht durch seine harmonische Kombination aus Komfort und Eleganz. Der zentrale Kamin und die gemütliche Sitzgruppe laden zum Verweilen ein. Die Galerie mit Büro und E-Piano sowie die ausgewählte Einrichtung schaffen eine inspirierende Atmosphäre."
    },
    {
      src: "/images/properties/mas-capon/web_livingroom.jpeg",
      alt: "Gemütliches Wohnzimmer mit Kamin",
      category: "Wohnzimmer",
      description: "Das lichtdurchflutete Wohnzimmer besticht durch seine harmonische Kombination aus Komfort und Eleganz. Der zentrale Kamin und die gemütliche Sitzgruppe laden zum Verweilen ein. Die Galerie mit Büro und E-Piano sowie die ausgewählte Einrichtung schaffen eine inspirierende Atmosphäre."
    },
    {
      src: "/images/properties/mas-capon/web_livingroom2.jpeg",
      alt: "Wohnbereich mit Galerie",
      category: "Wohnzimmer",
      description: "Das lichtdurchflutete Wohnzimmer besticht durch seine harmonische Kombination aus Komfort und Eleganz. Der zentrale Kamin und die gemütliche Sitzgruppe laden zum Verweilen ein. Die Galerie mit Büro und E-Piano sowie die ausgewählte Einrichtung schaffen eine inspirierende Atmosphäre."
    },
    // Lavendel Zimmer Group
    {
      src: "/images/properties/mas-capon/web_lavendel.jpeg",
      alt: "Lavendel Zimmer - Schlafbereich mit Gartenblick",
      category: "Schlafzimmer",
      roomGroup: "lavendel",
      description: "Das Lavendel Zimmer ist der perfekte Rückzugsort für Naturliebhaber. Mit seinem eleganten Kingsize-Bett und dem direkten Zugang zur Terrasse genießen Sie hier den Blick auf den duftenden Lavendelgarten. Die hohen Fenster lassen viel natürliches Licht herein und schaffen eine helle, einladende Atmosphäre. Die geschmackvolle Einrichtung in warmen Erdtönen und provenzalischen Akzenten sorgt für authentisches Südfrankreich-Flair."
    },
    {
      src: "/images/properties/mas-capon/web_lavendel_bath.jpeg",
      alt: "Lavendel Zimmer - Ensuite Badezimmer",
      category: "Schlafzimmer",
      roomGroup: "lavendel",
      description: "Das Lavendel Zimmer ist der perfekte Rückzugsort für Naturliebhaber. Mit seinem eleganten Kingsize-Bett und dem direkten Zugang zur Terrasse genießen Sie hier den Blick auf den duftenden Lavendelgarten. Die hohen Fenster lassen viel natürliches Licht herein und schaffen eine helle, einladende Atmosphäre. Die geschmackvolle Einrichtung in warmen Erdtönen und provenzalischen Akzenten sorgt für authentisches Südfrankreich-Flair."
    },
    // Strand Zimmer Group
    {
      src: "/images/properties/mas-capon/web_strand.jpeg",
      alt: "Strand Zimmer - Helles Schlafzimmer",
      category: "Schlafzimmer",
      roomGroup: "strand",
      description: "Inspiriert von der französischen Riviera, vereint das Strand Zimmer maritimes Flair mit modernem Komfort. Das luftige Queensize-Bett und die private Sonnenterrasse im ersten Stock bieten einen perfekten Start in den Tag. Die helle Farbgestaltung in Beige- und Blautönen erinnert an Sand und Meer, während ausgewählte Designerstücke dem Raum eine zeitlose Eleganz verleihen. Ein Highlight ist der unverbaubare Blick über die provenzalische Landschaft."
    },
    {
      src: "/images/properties/mas-capon/web_strand_bath.jpeg",
      alt: "Strand Zimmer - Modernes Badezimmer",
      category: "Schlafzimmer",
      roomGroup: "strand",
      description: "Inspiriert von der französischen Riviera, vereint das Strand Zimmer maritimes Flair mit modernem Komfort. Das luftige Queensize-Bett und die private Sonnenterrasse im ersten Stock bieten einen perfekten Start in den Tag. Die helle Farbgestaltung in Beige- und Blautönen erinnert an Sand und Meer, während ausgewählte Designerstücke dem Raum eine zeitlose Eleganz verleihen. Ein Highlight ist der unverbaubare Blick über die provenzalische Landschaft."
    },
    // Kräuter Zimmer Group
    {
      src: "/images/properties/mas-capon/web_kräuter.jpeg",
      alt: "Kräuter Zimmer - Elegantes Schlafzimmer",
      category: "Schlafzimmer",
      roomGroup: "kraeuter",
      description: "Das Kräuter Zimmer verzaubert mit seinem besonderen Charme und der Aussicht auf den mediterranen Kräutergarten. Der großzügige Raum besticht durch sein komfortables Kingsize-Bett und eine durchdachte Raumaufteilung. Die harmonische Kombination aus antiken Möbelstücken und modernen Elementen schafft eine einzigartige Atmosphäre. Die bodentiefen Fenster rahmen die malerische Gartenlandschaft ein und lassen den Duft der provenzalischen Kräuter erahnen."
    },
    {
      src: "/images/properties/mas-capon/web_sonnen.jpeg",
      alt: "Sonnenzimmer - Gemütliche Sitzecke",
      category: "Schlafzimmer",
      roomGroup: "kraeuter",
      description: "Das Sonnenzimmer ist hell und freundlich gestaltet, liegt im 1. Obergeschoss und teilt sich ein modernes Badezimmer mit dem Kräuter Zimmer. Warme Materialien und viel Tageslicht sorgen für eine einladende Atmosphäre."
    },
    {
      src: "/images/properties/mas-capon/web_upstairs_bath.jpeg",
      alt: "Kräuter Zimmer - Modernes Badezimmer",
      category: "Schlafzimmer",
      roomGroup: "kraeuter",
      description: "Das Kräuter Zimmer verzaubert mit seinem besonderen Charme und der Aussicht auf den mediterranen Kräutergarten. Der großzügige Raum besticht durch sein komfortables Kingsize-Bett und eine durchdachte Raumaufteilung. Die harmonische Kombination aus antiken Möbelstücken und modernen Elementen schafft eine einzigartige Atmosphäre. Die bodentiefen Fenster rahmen die malerische Gartenlandschaft ein und lassen den Duft der provenzalischen Kräuter erahnen."
    }
  ];

  const categories = ["Alle", "Küche & Esszimmer", "Wohnzimmer", "Schlafzimmer", "Garten & Pool"];
  const [activeCategory, setActiveCategory] = useState('Alle');

  const filteredImages = activeCategory === 'Alle' 
    ? images 
    : images.filter(img => img.category === activeCategory);

  // Group images by room when in Schlafzimmer category
  const groupedImages = activeCategory === 'Schlafzimmer'
    ? filteredImages.reduce((acc, img) => {
        if (!img.roomGroup) return acc;
        if (!acc[img.roomGroup]) {
          acc[img.roomGroup] = {
            images: [],
            description: img.description
          };
        }
        acc[img.roomGroup].images.push(img);
        return acc;
      }, {})
    : null;

  // Group images by category when not in 'Alle' view
  const groupedByCategory = activeCategory !== 'Alle'
    ? filteredImages.reduce((acc, img) => {
        if (!acc[img.category]) {
          acc[img.category] = {
            images: [],
            description: img.description
          };
        }
        acc[img.category].images.push(img);
        return acc;
      }, {})
    : null;

  // Group images by category and subcategory for Garten & Pool
  const groupedBySubcategory = activeCategory === 'Garten & Pool'
    ? filteredImages.reduce((acc, img) => {
        if (!acc[img.subcategory]) {
          acc[img.subcategory] = {
            images: [],
            description: img.description
          };
        }
        acc[img.subcategory].images.push(img);
        return acc;
      }, {})
    : null;

  // Flatten currently visible images for lightbox navigation
  const visibleImages = useMemo(() => {
    if (activeCategory === 'Alle') return filteredImages;
    if (activeCategory === 'Schlafzimmer' && groupedImages) {
      return Object.values(groupedImages).flatMap(g => g.images);
    }
    if (activeCategory === 'Garten & Pool' && groupedBySubcategory) {
      const order = ['house', 'pool'];
      return order.flatMap(key => (groupedBySubcategory[key]?.images) || []);
    }
    return filteredImages;
  }, [activeCategory, filteredImages, groupedImages, groupedBySubcategory]);

  const openLightboxFor = (image) => {
    const index = visibleImages.findIndex(i => i.src === image.src);
    setSelectedIndex(index >= 0 ? index : 0);
  };

  const closeLightbox = () => setSelectedIndex(null);
  const showPrev = (e) => {
    if (e) e.stopPropagation();
    if (!visibleImages.length) return;
    setSelectedIndex((prev) => (prev === null ? 0 : (prev - 1 + visibleImages.length) % visibleImages.length));
  };
  const showNext = (e) => {
    if (e) e.stopPropagation();
    if (!visibleImages.length) return;
    setSelectedIndex((prev) => (prev === null ? 0 : (prev + 1) % visibleImages.length));
  };

  useEffect(() => {
    if (selectedIndex === null) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showPrev();
      if (e.key === 'ArrowRight') showNext();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [selectedIndex, visibleImages.length]);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-8">
          {/* Category Filter */}
          <div className="flex gap-4 overflow-x-auto pb-2">
            {categories.map(category => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors
                  ${activeCategory === category 
                    ? 'bg-provence-lavender text-white' 
                    : 'bg-provence-stone/5 text-provence-stone/70 hover:bg-provence-stone/10'
                  }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="container mx-auto px-4 py-8">
        {activeCategory === 'Alle' ? (
          // Regular grid layout for 'Alle' category
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredImages.map((image) => (
              <div 
                key={image.src}
                className="relative aspect-[4/3] group cursor-pointer overflow-hidden rounded-lg shadow-md"
                onClick={() => openLightboxFor(image)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                  <p className="text-white font-medium">{image.alt}</p>
                </div>
              </div>
            ))}
          </div>
        ) : activeCategory === 'Schlafzimmer' ? (
          // Existing bedroom layout
          <div className="space-y-16">
            {Object.entries(groupedImages).map(([groupKey, group]) => (
              <div key={groupKey} className="bg-white rounded-xl border border-provence-lavender/20 shadow-md overflow-hidden">
                <div className="p-8 space-y-6">
                  <div>
                    <h2 className="text-2xl font-serif font-semibold text-provence-stone mb-4">
                      {groupKey === 'lavendel' ? 'Lavendel Zimmer' :
                       groupKey === 'strand' ? 'Strand Zimmer' :
                       'Kräuter Zimmer und Sonnenzimmer'}
                    </h2>
                    <p className="text-provence-stone/80 leading-relaxed">
                      {groupKey === 'kraeuter' 
                        ? 'Beide Zimmer liegen im 1. Obergeschoss und teilen sich ein modernes, gemeinsames Badezimmer. Großzügige Fenster sorgen für viel Tageslicht und bieten einen schönen Blick über den Garten.'
                        : group.description}
                    </p>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {group.images.map((image) => (
                      <div 
                        key={image.src}
                        className="relative aspect-[4/3] group cursor-pointer overflow-hidden rounded-lg shadow-md"
                        onClick={() => openLightboxFor(image)}
                      >
                        <img
                          src={image.src}
                          alt={image.alt}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                          <p className="text-white font-medium">{image.alt}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : activeCategory === 'Garten & Pool' ? (
          // Special layout for Garten & Pool with two boxes
          <div className="space-y-16">
            {/* House Views Box */}
            <div className="bg-white rounded-xl border border-provence-lavender/20 shadow-md overflow-hidden">
              <div className="p-8 space-y-6">
                <div>
                  <h2 className="text-2xl font-serif font-semibold text-provence-stone mb-4">
                    Garten
                  </h2>
                  <p className="text-provence-stone/80 leading-relaxed">
                    {groupedBySubcategory.house?.description}
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {groupedBySubcategory.house?.images.map((image) => (
                    <div 
                      key={image.src}
                      className="relative aspect-[4/3] group cursor-pointer overflow-hidden rounded-lg shadow-md"
                      onClick={() => openLightboxFor(image)}
                    >
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                        <p className="text-white font-medium">{image.alt}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Pool Area Box */}
            <div className="bg-white rounded-xl border border-provence-lavender/20 shadow-md overflow-hidden">
              <div className="p-8 space-y-6">
                <div>
                  <h2 className="text-2xl font-serif font-semibold text-provence-stone mb-4">
                    Pool
                  </h2>
                  <p className="text-provence-stone/80 leading-relaxed">
                    {groupedBySubcategory.pool?.description}
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {groupedBySubcategory.pool?.images.map((image) => (
                    <div 
                      key={image.src}
                      className="relative aspect-[4/3] group cursor-pointer overflow-hidden rounded-lg shadow-md"
                      onClick={() => openLightboxFor(image)}
                    >
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                        <p className="text-white font-medium">{image.alt}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : activeCategory === 'Küche & Esszimmer' ? (
          // Special layout for Küche & Esszimmer with 2 columns
          <div className="space-y-16">
            <div className="bg-white rounded-xl border border-provence-lavender/20 shadow-md overflow-hidden">
              <div className="p-8 space-y-6">
                <div>
                  <h2 className="text-2xl font-serif font-semibold text-provence-stone mb-4">
                    {activeCategory}
                  </h2>
                  <p className="text-provence-stone/80 leading-relaxed">
                    {filteredImages[0]?.description}
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {filteredImages.map((image) => (
                    <div 
                      key={image.src}
                      className="relative aspect-[4/3] group cursor-pointer overflow-hidden rounded-lg shadow-md"
                      onClick={() => openLightboxFor(image)}
                    >
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                        <p className="text-white font-medium">{image.alt}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          // Boxed layout for other categories
          <div className="space-y-16">
            <div className="bg-white rounded-xl border border-provence-lavender/20 shadow-md overflow-hidden">
              <div className="p-8 space-y-6">
                <div>
                  <h2 className="text-2xl font-serif font-semibold text-provence-stone mb-4">
                    {activeCategory}
                  </h2>
                  <p className="text-provence-stone/80 leading-relaxed">
                    {filteredImages[0]?.description}
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredImages.map((image) => (
                    <div 
                      key={image.src}
                      className="relative aspect-[4/3] group cursor-pointer overflow-hidden rounded-lg shadow-md"
                      onClick={() => openLightboxFor(image)}
                    >
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                        <p className="text-white font-medium">{image.alt}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && visibleImages[selectedIndex] && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-provence-lavender transition-colors"
            onClick={(e) => { e.stopPropagation(); closeLightbox(); }}
          >
            <X className="h-8 w-8" />
          </button>
          <button
            className="absolute left-4 md:left-8 text-white/80 hover:text-white transition-colors"
            onClick={showPrev}
          >
            <ChevronLeft className="h-10 w-10" />
          </button>
          <img
            src={visibleImages[selectedIndex].src}
            alt={visibleImages[selectedIndex].alt}
            className="max-w-full max-h-[90vh] object-contain"
            onClick={e => e.stopPropagation()}
          />
          <button
            className="absolute right-4 md:right-8 text-white/80 hover:text-white transition-colors"
            onClick={showNext}
          >
            <ChevronRight className="h-10 w-10" />
          </button>
          <p className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-lg">
            {visibleImages[selectedIndex].alt}
          </p>
        </div>
      )}
    </div>
  );
};

export default Gallery; 